module.exports = __webpack_public_path__ + "static/media/NigthTake3.48fe6509.jpeg";